import { useRef } from 'react'
import cx from 'classnames'
import useGlow from './hooks/useGlow'
import glows, { GlowType } from '@/ui/hooks/glows'

interface CanvasGlowProps {
  className?: string
  glowType: GlowType
  inset?: boolean
}

const CanvasGlow = ({
  glowType = 'Button',
  className,
  inset = false,
}: CanvasGlowProps) => {
  const ref = useRef<HTMLCanvasElement>(null)
  useGlow(ref, glows[glowType], inset)

  return <canvas ref={ref} className={cx('canvas-glow', className)} />
}

export default CanvasGlow
